import { render, staticRenderFns } from "./double2.vue?vue&type=template&id=947a59ac&scoped=true"
import script from "./double2.vue?vue&type=script&lang=ts"
export * from "./double2.vue?vue&type=script&lang=ts"
import style0 from "./double2.vue?vue&type=style&index=0&id=947a59ac&prod&scoped=true&lang=css"
import style1 from "./double2.vue?vue&type=style&index=1&id=947a59ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947a59ac",
  null
  
)

export default component.exports